import OofState from 'owa-service/lib/contract/OofState';
import MailboxAutoReplyConfigurationOptions from 'owa-service/lib/contract/MailboxAutoReplyConfigurationOptions';

export default function isOofSettingEnabled(
    mailboxAutoReplyConfigurationOptions: MailboxAutoReplyConfigurationOptions
): boolean {
    if (!mailboxAutoReplyConfigurationOptions) {
        return false;
    }

    return (
        mailboxAutoReplyConfigurationOptions.AutoReplyState === OofState.Enabled ||
        mailboxAutoReplyConfigurationOptions.AutoReplyState === OofState.Scheduled
    );
}
